import useLanguageNavigate from '@hooks/useLanguageNavigate';
import { mdiChevronRight } from '@mdi/js';
import Icon from '@mdi/react';
import { Button } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FindSpecialistModal } from '@features/FindSpecialist/components/FindSpecialistModal';
import { ExpressModal } from '@features/FindSpecialist/monitoring/components/modals/ExpressModal';
import { MonitoringModal } from '@features/FindSpecialist/monitoring/components/modals/MonitoringModal';
import { useTruncate } from '@hooks/useTruncate';
import express from 'assets/express.png';
import findSpecialist from 'assets/find-specialist.png';
import monitoring from 'assets/monitoring.png';
import classNames from 'classnames';

export const Services = () => {
	const { truncate } = useTruncate();
	const { navigateWithLanguage } = useLanguageNavigate();
	const { t, i18n } = useTranslation();
	const [openModal, setOpenModal] = useState<string | null>(null);

	const closeModal = () => setOpenModal(null);

	const servicesData = [
		{
			id: 'monitoring',
			title: t('servicesCards.monitoring.title'),
			description: truncate(t('servicesCards.monitoring.description'), 70),
			fullDescription: t('servicesCards.monitoring.description'),
			image: monitoring,
			link: '/farmer/services/monitoring/packages',
			ModalComponent: MonitoringModal,
		},
		{
			id: 'express',
			title: t('servicesCards.express.title'),
			description: truncate(t('servicesCards.express.description'), 70),
			fullDescription: t('servicesCards.express.description'),
			image: express,
			link: '/farmer/services/express/search',
			ModalComponent: ExpressModal,
		},
		{
			id: 'findSpecialist',
			title: t('servicesCards.oneTime.title'),
			description: truncate(t('servicesCards.oneTime.description'), 65),
			fullDescription: t('servicesCards.oneTime.description'),
			image: findSpecialist,
			link: '/farmer/services/specialist-request/search',
			ModalComponent: FindSpecialistModal,
		},
	];

	return (
		<div className="grid grid-cols-3 gap-6 w-full">
			{servicesData.map(
				({ id, title, description, fullDescription, image, link, ModalComponent }) => (
					<div key={id} className="flex-1 rounded-xl overflow-hidden shadow-lg bg-gray-100">
						<div
							className="w-full h-full bg-cover bg-center"
							style={{ backgroundImage: `url(${image})` }}
						>
							<div className="h-full p-[24px] flex flex-col justify-center gap-[10px]">
								<h3
									className={classNames(
										'text-body-text font-roboto text-2xl font-bold leading-normal uppercase',
										{
											'text-dark': id === 'monitoring',
											'text-white': id !== 'monitoring',
										}
									)}
								>
									{title}
								</h3>
								<p
									className={classNames(
										'text-body-text font-roboto text-base font-normal leading-normal',
										{
											'text-dark': id === 'monitoring',
											'text-white': id !== 'monitoring',
										}
									)}
								>
									{description} <br />
									<span
										onClick={() => setOpenModal(id)}
										className={classNames(
											'font-roboto text-base font-bold underline cursor-pointer',
											{
												'text-dark': id === 'monitoring',
												'text-white': id !== 'monitoring',
											}
										)}
									>
										{t('learnMore')}
									</span>
								</p>
								<Button
									variant="contained"
									className="text-white px-4 py-2 rounded-lg hover:bg-green-700 w-fit"
									onClick={() => navigateWithLanguage(link)}
									endIcon={<Icon path={mdiChevronRight} size={1} />}
								>
									{t('requestNow')}
								</Button>
							</div>
						</div>
						{openModal === id && (
							<ModalComponent open={true} onClose={closeModal} description={fullDescription} />
						)}
					</div>
				)
			)}
		</div>
	);
};
